import styled from 'styled-components';
import { tokens } from '../modal-form/tokens';

export const SeloHeader = styled.button`
  background: none;
  border: 1px solid #1f467e;
  color: #1f467e;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: all 0.2s ease;
  margin-right: 6px;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    background-color: #1f467e;
    color: white;
  }

  &:hover span {
    background: rgba(255, 255, 255, 0.18);
    color: white;
  }

  @media (max-width: 900px) {
    font-size: 0;
    gap: 0;
    padding: 6px;

    svg { font-size: 14px; }
    span { display: none; }
  }
`;

export const TagSelo = styled.span`
  background: #e9f5ff;
  color: #1f467e;
  border-radius: 10px;
  padding: 0 6px;
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
`;

export const Cabecalho = styled.div`
  position: relative;
  padding: 22px 24px 20px;
  color: #fff;
  font-family: ${tokens.fontFamily};
  background:
    repeating-linear-gradient(135deg, rgba(255, 255, 255, 0.04) 0 14px, transparent 14px 28px),
    ${tokens.primaryGradient};
  border-radius: 8px 8px 0 0;
`;

export const Fechar = styled.button`
  position: absolute;
  top: 12px;
  right: 14px;
  border: none;
  background: none;
  color: rgba(255, 255, 255, 0.8);
  font-size: 18px;
  line-height: 1;
  padding: 4px;
  cursor: pointer;

  &:hover { color: #fff; }
  &:disabled { opacity: 0.35; cursor: not-allowed; }
`;

export const Kicker = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.75);
  margin-bottom: 6px;
`;

export const Titulo = styled.h2`
  margin: 0 0 6px;
  font-size: 1.5rem;
  font-weight: 700;
  color: #fff;
`;

export const Paragrafo = styled.p`
  margin: 0;
  font-size: ${tokens.fontBase};
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.5;
  max-width: 540px;
`;

export const LinhaDestaque = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  margin-top: 14px;
`;

export const Etiqueta = styled.span`
  display: inline-block;
  background: #fff;
  color: #1F467E;
  font-weight: 700;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  padding: 8px 18px 8px 14px;
  clip-path: polygon(0 0, 100% 0, calc(100% - 10px) 50%, 100% 100%, 0 100%);
`;

export const Contador = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: rgba(255, 255, 255, 0.85);
  font-size: ${tokens.fontSm};

  b {
    color: #fff;
    font-size: 1.05rem;
    font-weight: 700;
  }
`;

export const Corpo = styled.div`
  padding: 6px 24px 24px;
  font-family: ${tokens.fontFamily};
`;

export const Abas = styled.div`
  display: flex;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 18px;
`;

export const Aba = styled.button<{ $ativa: boolean }>`
  border: none;
  background: none;
  padding: 10px 14px;
  font-size: 14px;
  font-weight: 500;
  color: ${p => p.$ativa ? '#1F467E' : '#6b7280'};
  cursor: pointer;
  border-bottom: 2px solid ${p => p.$ativa ? '#1F467E' : 'transparent'};
  margin-bottom: -1px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: inherit;

  @media (max-width: 640px) {
    flex: 1;
    justify-content: center;
    span.titulo { display: none; }
  }
`;

export const Mini = styled.img`
  width: 18px;
  height: 18px;
  border-radius: 4px;
  object-fit: cover;
`;

export const MiniIcone = styled.span`
  width: 18px;
  height: 18px;
  border-radius: 4px;
  background: #1F467E;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`;

export const Painel = styled.div`
  display: flex;
  gap: 22px;
  align-items: flex-start;

  @media (max-width: 640px) {
    flex-direction: column;
  }
`;

export const Tile = styled.div`
  width: 112px;
  height: 112px;
  flex: 0 0 112px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  background: #fff;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const TileIcone = styled(Tile)`
  border: none;
  background: ${tokens.primaryGradient};
  color: #fff;
  font-size: 52px;
`;

export const Texto = styled.div`
  flex: 1;
  min-width: 0;

  h3 {
    margin: 0 0 6px;
    font-size: 1.05rem;
    font-weight: 600;
    color: ${tokens.textPrimary};
  }

  p {
    margin: 0 0 10px;
    font-size: ${tokens.fontMd};
    color: ${tokens.textSecondary};
    line-height: 1.55;
  }
`;

export const TagOferta = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #e9f5ff;
  color: #1F467E;
  font-size: ${tokens.fontSm};
  font-weight: 600;
  border-radius: 6px;
  padding: 5px 10px;
  margin: 2px 0 14px;
`;

export const Acoes = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
`;

export const Botao = styled.button`
  background: ${tokens.primaryGradient};
  color: #fff;
  border: 0;
  border-radius: 6px;
  padding: 9px 16px;
  font-size: ${tokens.fontMd};
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: inherit;

  &:hover { background: ${tokens.primaryGradientHover}; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

export const BotaoInteresse = styled(Botao)`
  padding: 12px 24px;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.2px;
  box-shadow: 0 4px 14px rgba(31, 70, 126, 0.35);
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  svg { font-size: 18px; }

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 18px rgba(31, 70, 126, 0.45);
  }
`;

export const BotaoWhatsApp = styled.a`
  background: ${tokens.primaryGradient};
  color: #fff;
  border-radius: 6px;
  padding: 9px 16px;
  font-size: ${tokens.fontMd};
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;

  &:hover {
    background: ${tokens.primaryGradientHover};
    color: #fff;
    text-decoration: none;
  }

  svg { font-size: 18px; }
`;

export const Confirmacao = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #e6f4ea;
  color: #1e7e34;
  border-radius: 6px;
  padding: 9px 16px;
  font-size: ${tokens.fontMd};
  font-weight: 600;
`;

export const Nota = styled.span`
  font-size: ${tokens.fontXs};
  color: ${tokens.textMuted};
`;

export const CampoTelefone = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
  flex-wrap: wrap;

  label {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: ${tokens.fontXs};
    font-weight: 600;
    color: ${tokens.textMuted};
    text-transform: uppercase;
  }

  input {
    height: 36px;
    width: 180px;
    padding: 0 10px;
    border: 1px solid ${tokens.borderDefault};
    border-radius: 6px;
    font-size: ${tokens.fontMd};
    color: ${tokens.textPrimary};
  }

  input:focus {
    outline: none;
    border-color: ${tokens.borderFocus};
  }
`;

export const Rodape = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 22px;
  padding-top: 14px;
  border-top: 1px solid #e9ecef;
  font-size: ${tokens.fontSm};
  color: ${tokens.textMuted};

  button {
    border: none;
    background: none;
    color: #1F467E;
    font-weight: 600;
    cursor: pointer;
    font-size: ${tokens.fontSm};
    font-family: inherit;
  }

  button:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;
